var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Button, Icon } from "@opala-ds/react";
import { useRef, useState } from "react";
import { cn } from "../utils/cn";
var channels = [
    {
        icon: {
            iconName: "MessageCircle",
            iconBg: "bg-[#C1EED3]",
            iconColor: "text-[#167974]",
        },
        title: "WhatsApp",
        description: "Dúvidas sobre o acesso ao Gov.pi? Chama a gente no WhatsApp.",
        href: "https://api.whatsapp.com/send/?phone=86988788533&text=Ol%C3%A1%21+gostaria+de+atendimento...&type=phone_number&app_absent=0",
        slug: "86988788533",
        buttonLabel: "Falar no WhatsApp",
    },
    {
        icon: {
            iconName: "MailOpen",
            iconBg: "bg-[#EDE8F3]",
            iconColor: "text-[#977BBA]",
        },
        title: "E-mail",
        description: "Dúvidas sobre o acesso ao Gov.pi? Envie um e-mail para a gente.",
        href: "mailto:suporte.govpi@etipi.pi.gov.br",
        slug: "suporte.govpi@etipi.pi.gov.br",
        buttonLabel: "Falar no E-mail",
    },
];
export default function Support() {
    var _a = useState(null), copiedKey = _a[0], setCopiedKey = _a[1];
    var copiedTimeoutRef = useRef(null);
    function openChannel(href) {
        if (!href.startsWith("mailto:")) {
            window.open(href, "_blank", "noopener noreferrer");
            return;
        }
        var a = document.createElement("a");
        a.href = href;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    }
    function copyTextToClipboard(text, key) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!text)
                            return [2 /*return*/];
                        if (!(navigator.clipboard && window.isSecureContext)) return [3 /*break*/, 2];
                        return [4 /*yield*/, navigator.clipboard.writeText(text)];
                    case 1:
                        _a.sent();
                        setCopiedKey(key);
                        if (copiedTimeoutRef.current) {
                            window.clearTimeout(copiedTimeoutRef.current);
                        }
                        copiedTimeoutRef.current = window.setTimeout(function () {
                            setCopiedKey(null);
                        }, 1000);
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    }
    return (_jsxs("div", __assign({ className: "flex flex-col gap-6" }, { children: [_jsxs("div", __assign({ className: "text-center flex flex-col md:space-y-0 space-y-6" }, { children: [_jsx("h2", __assign({ className: "text-[#262626] md:text-3xl font-bold text-xl text-balance" }, { children: "Suporte ao Gov.pi" })), _jsx("p", __assign({ className: "text-fg-moderate-default md:text-[14px] md:leading-relaxed tracking-wide text-base text-balance w-full text-center" }, { children: "Escolha a op\u00E7\u00E3o que preferir para receber um atendimento humanizado. Nossa equipe est\u00E1 pronta para ouvir e tirar suas d\u00FAvidas." }))] })), _jsx("div", __assign({ className: "flex md:flex-row flex-col justify-center items-center gap-4" }, { children: channels.map(function (channel) { return (_jsxs("div", __assign({ className: "flex flex-col justify-between p-5 bg-[#F9FCFF] border border-[#E6E6E6] rounded-3xl md:max-w-64 md:w-auto w-full md:min-h-72 space-y-4 md:space-y-0" }, { children: [_jsx("div", __assign({ className: cn("flex items-center justify-center w-14 h-14 rounded-xl m-0", channel.icon.iconBg) }, { children: channel.icon.iconName !== "MailOpen" ? (_jsx("img", { src: "".concat(process.env.PUBLIC_URL, "/whats.png"), alt: "whats", width: 32, height: 32, className: channel.icon.iconColor })) : (_jsx(Icon, { name: channel.icon.iconName, width: 32, height: 32, className: channel.icon.iconColor })) })), _jsx("h3", __assign({ className: "text-xl leading-normal font-bold text-fg-moderate-default text-balance" }, { children: channel.title })), _jsx("p", __assign({ className: "text-sm leading-snug text-fg-moderate-default text-balance" }, { children: channel.description })), _jsx("div", __assign({ className: cn("flex items-center gap-2 text-[12px] leading-none cursor-pointer duration-200 text-[#419AFF]", copiedKey === channel.title && "animate-bounce-in"), onClick: function () { return copyTextToClipboard(channel.slug, channel.title); } }, { children: copiedKey === channel.title ? (_jsxs(_Fragment, { children: [_jsx(Icon, { name: "Check", size: 12 }), _jsx("p", { children: "Copiado!" })] })) : (_jsxs(_Fragment, { children: [_jsx(Icon, { name: "Copy", size: 12 }), _jsxs("p", { children: ["Copiar", " ", channel.icon.iconName === "MailOpen" ? "e-mail" : "número"] })] })) })), _jsx(Button, __assign({ onClick: function () { return openChannel(channel.href); }, leftIcon: "ExternalLink", className: "w-full" }, { children: channel.buttonLabel }))] }), channel.title)); }) }))] })));
}
